import { call, put } from 'redux-saga/effects';

import { getMessages } from '@api/messages';
import { intl } from '@helpers/intl';
import { messageDetailGetModel } from '@models/messages';
import {
  messagesDetailGetSuccessAction,
  messagesDetailGetFailureAction,
} from '@store/messages/messagesDetail/messagesDetail.actions';
import { toastError } from '@store/notifications';

export const handleGetMessageThreads = function* ({ payload }) {
  try {
    const response = yield call(getMessages, payload);

    const data = yield call(messageDetailGetModel, response.results);

    yield put(messagesDetailGetSuccessAction(data));
  } catch (error) {
    const errorMessage =
      error.data?.nonFieldErrors ||
      intl.formatMessage({
        defaultMessage: 'An unexpected error occurred, please try again.',
        id: 'global.notification.api-error-default',
      });

    yield put([
      toastError({
        message: errorMessage,
      }),
      messagesDetailGetFailureAction({ errorMessage }),
    ]);
  }
};
